import * as types from './session.actionTypes';
import bugsnagClient from '../../ui/containers/BugsnagClient';
import clearState from './meta.actions';
import { endpointWrapper } from 'utils/api/meta.api';
import { fetchUserAbout } from 'utils/api/user.api';
import md5 from 'md5';
import { mixpanelTrack } from 'utils/app';

const globalScope = typeof globalThis !== 'undefined' ? globalThis : window;

const updateSession = (payload) => ({ type: types.UPDATE_SESSION, payload });
const deleteSession = () => ({ type: types.DESTROY_SESSION });

const getMixpanelUserId = (user) => md5(user.email);

const track = async (data, attempt = 1) => {
    try {
        await endpointWrapper({
            domain: 'metrics/track',
            method: 'POST',
            data,
        });
    } catch (error) {
        if (attempt < 3) {
            await new Promise((resolve) =>
                setTimeout(resolve, Math.pow(2, attempt) * 1000),
            );
            await track(data, attempt + 1);
        } else {
            throw error;
        }
    }
};

export const trackLoginForMetrics = async (user) => {
    const email = user.email;
    const mixpanelUserId = getMixpanelUserId(user);
    if (!(email && mixpanelUserId)) return;
    const lastLogin = new Date().toISOString();
    const emailDomain = email.replace(/.*@/, '');
    track({
        eventName: 'Login',
        email,
        emailDomain,
        mixpanelUserId,
        lastLogin,
    });
};

export const trackLogin = () => (dispatch) => {
    mixpanelTrack('Login');
    if (globalScope.mixpanel)
        globalScope.mixpanel.people.set({ $last_login: new Date() });
};

export const handleLoginResponse = (user) => async (dispatch) => {
    const { sub, email } = user;
    const mixpanelUserId = getMixpanelUserId(user);
    if (!globalScope.mixpanel) {
        console.warn('Mixpanel not found');
    } else {
        globalScope.mixpanel.identify(mixpanelUserId);
        const emailDomain = user.email.replace(/.*@/, '');
        globalScope.mixpanel.people.set({
            $email: email,
            emailDomain,
        });

        try {
            const userAbout = await fetchUserAbout();
            const clientInfo = userAbout?.client_info || {};
            const userProps = {};
            if (clientInfo.client_name)
                userProps.client_name = clientInfo.client_name;
            if (clientInfo.client_id)
                userProps.client_id = clientInfo.client_id;
            if (clientInfo.client_tier)
                userProps.client_tier = clientInfo.client_tier;
            if (userAbout?.profile?.role)
                userProps.role = userAbout.profile.role;
            if (Object.keys(userProps).length > 0) {
                globalScope.mixpanel.people.set(userProps);
            }
        } catch (e) {
            console.warn('Failed to fetch user data for Mixpanel', e);
        }
    }
    dispatch(
        updateSession({
            ...user,
            user_id: sub,
            user_email: email,
            mixpanelUserId,
        }),
    );
};

export const completeLogoutProcess = () => async (dispatch) => {
    mixpanelTrack('Logout');
    if (!globalScope.mixpanel) {
        console.warn('Mixpanel not found');
        bugsnagClient.notify('Mixpanel not found');
    } else {
        globalScope.mixpanel.reset(); // in case multiple users on same device
    }
    if (globalScope.productFruits?.services?.destroy) {
        globalScope.productFruits.services.destroy();
    }
    await dispatch(clearState());
    await dispatch(deleteSession());
};
